export default __webpack_public_path__ + "static/media/Weather3.fb582840.png";